import { Component } from '@angular/core';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  stagger,
} from '@angular/animations';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { KycTokenSubmissionService } from 'src/app/shared/services/kyc-token-submission.service';

// MPS-215  Gate page for the KYC token-based submission flow. Mirrors
// the RFQ-quote tokenLogin pattern: the supplier types the Unique
// Access Token they received in their invitation email and clicks
// Login. On a successful verify we navigate to the existing KYC
// upload page with the token in the query string — the upload page
// re-verifies on its own and renders the document slots.
@Component({
  selector: 'app-kyc-token-login',
  templateUrl: './kycTokenLogin.component.html',
  styleUrls: ['./kycTokenLogin.component.css'],
  animations: [
    trigger('pageFadeUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(100vh)' }),
        animate(
          '1200ms cubic-bezier(.22,1,.36,1)',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
    trigger('staggerFadeUp', [
      transition(':enter', [
        query(
          '.stagger-item',
          [
            style({ opacity: 0, transform: 'translateY(13px)' }),
            stagger(80, [
              animate(
                '350ms ease-out',
                style({ opacity: 1, transform: 'translateY(0)' })
              ),
            ]),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class KycTokenLoginComponent {
  securityToken = '';
  loading = false;

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private tokenApi: KycTokenSubmissionService
  ) {}

  async verifyToken(): Promise<void> {
    const raw = (this.securityToken || '').trim();
    if (!raw) {
      this.snackBar.open('Please enter a valid Security Token', 'Close', {
        duration: 3000,
      });
      return;
    }

    this.loading = true;
    try {
      const data = await this.tokenApi.verify(raw);
      if (data?.valid) {
        this.snackBar.open('Token verified successfully', 'Close', {
          duration: 2500,
        });
        this.router.navigate(['/kycToken/submit'], {
          queryParams: { token: raw },
        });
      } else if (data?.reason === 'EXPIRED_TOKEN') {
        this.snackBar.open(
          'This token has expired. Please contact the buyer for a fresh invitation.',
          'Close',
          { duration: 4000 }
        );
      } else {
        this.snackBar.open(
          'Invalid token. Please check and try again.',
          'Close',
          { duration: 3500 }
        );
      }
    } catch {
      this.snackBar.open('Verification failed. Please try again.', 'Close', {
        duration: 3500,
      });
    } finally {
      this.loading = false;
    }
  }
}
